import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

const LINES = [
    { cmd: "whoami", out: "harshdeep-singh" },
    { cmd: "focus", out: "cybersecurity / penetration-testing" },
    { cmd: "status", out: "learning • building • testing" },
];

export const Terminal = () => {
    const reduce = useReducedMotion();
    const [lineIdx, setLineIdx] = useState(reduce ? LINES.length : 0);
    const [charIdx, setCharIdx] = useState(0);
    const [showOut, setShowOut] = useState(false);

    useEffect(() => {
        if (reduce || lineIdx >= LINES.length) return undefined;
        const line = LINES[lineIdx];
        let t;
        if (!showOut) {
            if (charIdx < line.cmd.length) {
                t = setTimeout(() => setCharIdx((c) => c + 1), 55 + Math.random() * 60);
            } else {
                t = setTimeout(() => setShowOut(true), 320);
            }
        } else {
            t = setTimeout(() => {
                setLineIdx((i) => i + 1);
                setCharIdx(0);
                setShowOut(false);
            }, 620);
        }
        return () => clearTimeout(t);
    }, [charIdx, showOut, lineIdx, reduce]);

    const done = lineIdx >= LINES.length;

    return (
        <div
            data-testid="hero-terminal"
            className="w-full overflow-hidden border border-white/10 bg-surface/80 shadow-[0_0_60px_rgba(0,255,102,0.06)] backdrop-blur-md"
        >
            <div className="flex items-center gap-2 border-b border-white/5 bg-black/40 px-4 py-3">
                <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
                <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
                <span className="h-2.5 w-2.5 rounded-full bg-neon/70" />
                <span className="ml-3 font-mono2 text-[11px] tracking-wider text-zinc-500">
                    harshdeep@sec: ~/portfolio
                </span>
            </div>
            <div className="min-h-[188px] space-y-3 px-5 py-5 font-mono2 text-[13px] leading-relaxed sm:text-sm">
                {LINES.slice(0, lineIdx).map((line) => (
                    <div key={line.cmd}>
                        <p className="text-zinc-400">
                            <span className="text-neon">$</span> {line.cmd}
                        </p>
                        <p className="text-cyber/90">{line.out}</p>
                    </div>
                ))}
                {!done && (
                    <p className="text-zinc-400">
                        <span className="text-neon">$</span>{" "}
                        {LINES[lineIdx].cmd.slice(0, charIdx)}
                        <span className="ml-0.5 inline-block h-4 w-2 translate-y-0.5 animate-blink bg-neon" />
                    </p>
                )}
                {!done && showOut && (
                    <p className="text-cyber/90">{LINES[lineIdx].out}</p>
                )}
                {done && (
                    <p className="text-zinc-400">
                        <span className="text-neon">$</span>
                        <span className="ml-2 inline-block h-4 w-2 translate-y-0.5 animate-blink bg-neon" />
                    </p>
                )}
            </div>
        </div>
    );
};
